import axios from 'axios';
import { Project, Skill, SkillsByCategory, Experience, Education, Certification, BlogPost, ContactFormData } from '@/types';

const API_BASE = process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  headers: { 'Content-Type': 'application/json' },
});

export const projectsApi = {
  getAll: () => api.get<{ results?: Project[] }>('/projects/').then(r => r.data.results ?? r.data),
  getFeatured: () => api.get<{ results?: Project[] } | Project[]>('/projects/featured/').then(r => (r.data as any).results ?? r.data),
  getOne: (id: number) => api.get<Project>(`/projects/${id}/`).then(r => r.data),
};

export const skillsApi = {
  getAll: () => api.get<{ results?: Skill[] } | Skill[]>('/skills/').then(r => (r.data as any).results ?? r.data),
  getByCategory: () => api.get<SkillsByCategory>('/skills/by_category/').then(r => r.data),
};

export const experienceApi = {
  getAll: () => api.get<{ results?: Experience[] } | Experience[]>('/experience/').then(r => (r.data as any).results ?? r.data),
  getEducation: () => api.get<{ results?: Education[] } | Education[]>('/education/').then(r => (r.data as any).results ?? r.data),
};

export const certificationsApi = {
  getAll: () => api.get<{ results?: Certification[] } | Certification[]>('/certifications/').then(r => (r.data as any).results ?? r.data),
};

export const blogApi = {
  getAll: () => api.get<{ results?: BlogPost[] } | BlogPost[]>('/blog/').then(r => (r.data as any).results ?? r.data),
  getOne: (slug: string) => api.get<BlogPost>(`/blog/${slug}/`).then(r => r.data),
};

export const contactApi = {
  send: (data: ContactFormData) => api.post('/contact/', data).then(r => r.data),
};
